import { createTable } from "robodux";
import { createSelector } from "reselect";
import { put, call, select } from "saga-query";
import { api, thunks } from "../apis/api";
import { encryptPayoad, ensureArray } from "@app/service/helpers";

import type { TDirectoryType, TDirinfo } from "@app/types";
import type { RootState } from "@app/state/rootState";

const REPO_DIRINFO_TYPES = "dirinfo/all-types";

export const dirinfoType = createTable<TDirectoryType>({
  name: REPO_DIRINFO_TYPES,
  initialState: {},
});

const dirinfoSelector = (state: RootState) => state[REPO_DIRINFO_TYPES];
export const selectDirInfoTypes = createSelector(
  dirinfoSelector,
  (dirinfo) => dirinfo
);

export const setDirTypes = thunks.create<TDirectoryType[]>(
  "setDirTypes",
  function* (ctx, next) {
    const dirinfo = ctx.payload.reduce((acc, item) => {
      acc[item.DIR_TYPE] = item;
      return acc;
    }, {} as Record<string, TDirectoryType>);
    yield* put(dirinfoType.actions.set(dirinfo));
  }
);

const REPO_DIRINFO_DATA = "dirinfo/all-data";
export const dirinfoData = createTable<TDirinfo>({
  name: REPO_DIRINFO_DATA,
  initialState: {},
});

const dirinfoDataSelector = (s: RootState) => dirinfoData.getSelectors(s);

export const selectDirInfoData = createSelector(
  dirinfoDataSelector,
  (s) => s.selectTable
);

export const setDirInfoData = thunks.create<TDirinfo[]>(
  "setDirInfoData",
  function* (ctx, next) {
    const dirinfo = ensureArray(ctx.payload).reduce((acc, item) => {
      acc[item.SD_ID] = item;
      return acc;
    }, {} as Record<string, TDirinfo>);
    yield* put(dirinfoData.actions.set(dirinfo));
    yield* next();
  }
);
